import { Injectable } from '@angular/core';
import { AuthorizationProperties } from '../authentication/auth-info';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { LoginService } from '../core/services/login.service';
import { StoreRolesService } from '../core/services/store-role.service';
import { CustomerService } from '../core/services/customer.service';
import { TbAuthService } from '@tb/auth';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RoleGuardService {
    authorizationStored;
    authorizationProperties: AuthorizationProperties;

    constructor(
        private router: Router,
        private loginService: LoginService,
        private customerService: CustomerService,
        private storeRoleService: StoreRolesService,
        private authService: TbAuthService
    ) {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
    }
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        let roles = route.data.roles as Array<string>;
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        if (this.authorizationProperties === null || this.authorizationProperties === undefined) {
            this.router.navigate(['/home']);
            return of(false);
        }
        return this.storeRoleService.storeRoles$.map((storeRoles) => {
            if (storeRoles.length == 0) {
                this.router.navigate(['/mydashboard']);
                return false;
            }

            let atleastOne = 0;
            for (let index = 0; index < roles.length; index++) {
                const element = roles[index];
                let exists = this.storeRoleService.storeRoles.find((x) => x.toLowerCase() == element.toLowerCase());
                if (exists) {
                    atleastOne++;
                }
            }
            if (atleastOne == 0) {
                this.router.navigate(['/mydashboard']);
                return false;
            } else return true;
        });
    }
}
